module.exports = __webpack_public_path__ + "static/media/left.8c8ba965.svg";